(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eulique-automata-styles"] && !Shopify.designMode) return;
  try {
    function mountAutomataOptions(root = document) {
    for (const container of root.querySelectorAll('.ea-product .gpo-container')) {
      if (container.closest('.ea-options') || !container.children.length) continue;
      const disclosure = document.createElement('details');
      disclosure.className = 'ea-options';
      const summary = document.createElement('summary');
      summary.textContent = container.closest('.ea-product').dataset.optionsLabel;
      disclosure.append(summary);
      container.before(disclosure);
      disclosure.append(container);
      container.addEventListener('invalid', () => { disclosure.open = true; }, true);
    }
  }
  mountAutomataOptions();
  const automataObserver = new MutationObserver(() => mountAutomataOptions());
  function observeAutomataOptions() {
    automataObserver.disconnect();
    const productRoot = document.querySelector('.ea-product');
    if (productRoot) automataObserver.observe(productRoot, { childList: true, subtree: true });
    mountAutomataOptions();
  }
  observeAutomataOptions();
  document.addEventListener('shopify:section:load', observeAutomataOptions);
  } catch(e) { console.error(e); }
})();

})();
